import { EstimateType } from "./estimate-type";

export abstract class Estimate {
    public type: EstimateType;

    constructor(type: EstimateType) {
        this.type = type;
    }

    public abstract total: number;
}